import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import type { VariantProps } from "class-variance-authority";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";
import { dropdownLabelVariants } from "./styles";

export type DropdownMenuLabelProps = ComponentProps<typeof DropdownMenuPrimitive.Label> &
  VariantProps<typeof dropdownLabelVariants> & {
    inset?: boolean;
  };

export const Label = ({ ref, className, inset, variant, ...props }: DropdownMenuLabelProps) => (
  <DropdownMenuPrimitive.Label
    ref={ref}
    className={cn(dropdownLabelVariants({ variant }), inset && "pl-8", className)}
    {...props}
  />
);

Label.displayName = DropdownMenuPrimitive.Label.displayName;
